import { Link, Meta } from '@solidjs/meta';
import { useSite } from 'Shared/SiteProvider';
import { canonicalUrl } from 'Shared/frontend/PageMeta';
import { RouteDefinition, useLocation, useNavigate } from '@solidjs/router';
import { onMount } from 'solid-js';

export interface IRoutesProvider 
{
	routes(): RouteDefinition[];
}



/* Good for most local redirects, provided permissions are OK */
export function Navigate(P:{url:string})
{
	useNavigate()(P.url);
	return <></>
}


export function GeneralRedirect(P:{url:string})
{
/* XXX REDIRECT POSSIBILITIES:
1. Solid Routers redirect() - currently only works in action() and event handlers. May change in time.
		Subscribed to this bug https://github.com/solidjs/solid-router/issues/429
   This method would remove an unnecessary page load.
2. Express response object ==> Tried this. Seems Solid Router has already sent headers to the client.
   This method would remove an unnecessary page load.
3. Send <meta> direct in HTML 
*/

//XXX NOTE the redirect page probably has some unnecessary extra content...
	return (
		<Meta http-equiv='refresh' content={`0; url=${P.url}`}/>
	);
}


/*
	Lands the '/redirected/' prefix that the load balancer adds when stripping 'www.', and rewrites
	the URL back to the real path.

	This MUST stay client-side. Sites migrated from hosting that canonicalised on 'www.' leave a
	permanently cached 301 (apex -> www) in visitors' browsers, so any HTTP navigation to the apex
	(a meta refresh included) re-enters that 301 and loops until the browser gives up. Navigating
	through the router issues no request, so the cached 301 is never consulted.
*/
export function StripRedirectedPrefix()
{
	const location = useLocation();
	const navigate = useNavigate();
	const path = location.pathname.replace(/^\/redirected/,'').replace(/\/+$/,'') || '/';
	const site = useSite();

	onMount(() => navigate(path + location.search, {replace:true}));

	/* Crawlers see this page before the navigation, if at all */
	return <Link rel='canonical' href={canonicalUrl(site.hostUrl,path)} />;
}

